<template>
  <div class="conflicting-apps-pill" v-if="conflictingApps && conflictingApps.length > 0">
    <div class="pill-content">
      <i class="fas fa-exclamation-triangle"></i>
      <span>{{ $t('conflictingApps') }}: {{ conflictingApps.join(', ') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConflictingAppsPill',
  props: {
    conflictingApps: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.conflicting-apps-pill {
  position: fixed;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff4444;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.pill-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pill-content i {
  font-size: 1rem;
}
</style> 